var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "m9.058 8 6.225-6.218A.753.753 0 1 0 14.218.717L8 6.942 1.783.717A.753.753 0 0 0 .718 1.782L6.943 8 .718 14.217a.75.75 0 0 0 0 1.065.75.75 0 0 0 1.065 0L8 9.057l6.218 6.225a.751.751 0 0 0 1.287-.532.75.75 0 0 0-.222-.533z"
  })));
};
export default SvgCross;